import {baseSupplementExtensions} from '../supplementHelpers/baseSupplement.extensions';

export const extensions = {
  ...baseSupplementExtensions
};
